import { Component, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FlowManagerService } from '../services/flowmanager.service';
import { ApplicationActions } from '../../actions/application.actions';
import { ApplicationProxyService } from '../services/applicationproxy.service';
import { ModalService } from '../services/modal.service';
import { Validation } from '../services/validation.service';
import * as _ from 'lodash';

@Component({
  selector: 'base-route-not-used',
  template: ''
})
export class BaseRoute {
  // Drop in all our common dependencies
  constructor(injector: Injector) {
    this.router = injector.get(Router);
    this.flowManager = injector.get(FlowManagerService);
    this.appActions = injector.get(ApplicationActions);
    this.appProxy = injector.get(ApplicationProxyService);
    this.route = injector.get(ActivatedRoute);
    this.modal = injector.get(ModalService);
    this.validation = injector.get(Validation);

    this.form = this.route.data.value.formData;
    this.loadingNext = false;
  }

  // Can be used for routes that dont need any explicit button logic
  btnClick(e) {
    this.handleClick(e.action);
  }

  handleClick(action) {
    const actionRoute = this.getActionRoute(action);
    const router = this.router;
    if (actionRoute) {
      window.requestAnimationFrame(() => {
        router.navigate([actionRoute], { queryParamsHandling: 'preserve' });
      });
      _.each(this.form.buttons.inputs, (input, key) => {
        /* eslint-disable */
        input.disabled = true;
        /* eslint-enable */
      });

      const actionButton = this.form.buttons.inputs[action];
      actionButton.classes += ' spinner';
    }
  }

  // Used by button handler, but can also be used in click logic per route
  getActionRoute(action) {
    const actionButton = this.form.buttons.inputs[action];
    if (actionButton != null && actionButton.path != null) {
      return actionButton.path;
    }

    return null;
  }

  get loadingClass() {
    return {
      spinner: this.loadingNext
    };
  }

  triggerLoading() {
    this.loadingNext = true;
  }
}
